/**
 * Skeleton de Minhas finanças — header padrão + cards de saldo/resumo
 * + lista de transações do mês.
 */
export default function Loading() {
  return (
    <div className="mx-auto flex max-w-7xl animate-pulse flex-col gap-6">
      {/* PageHeader */}
      <div className="h-[104px] rounded-[20px] bg-slate-200" />

      {/* Cards de resumo (receitas / gastos / investimentos / saldo) */}
      <div className="grid grid-cols-2 gap-4 lg:grid-cols-4">
        {Array.from({ length: 4 }).map((_, i) => (
          <div key={i} className="h-28 rounded-xl border border-slate-200 bg-white p-4">
            <div className="h-3 w-24 rounded bg-slate-200" />
            <div className="mt-3 h-6 w-28 rounded bg-slate-200" />
          </div>
        ))}
      </div>

      {/* Lista de transações */}
      <div className="rounded-xl border border-slate-200 bg-white p-4">
        <div className="flex items-center justify-between">
          <div className="h-4 w-40 rounded bg-slate-200" />
          <div className="h-9 w-32 rounded-lg bg-slate-200" />
        </div>
        <div className="mt-4 flex flex-col gap-2">
          {Array.from({ length: 6 }).map((_, i) => (
            <div key={i} className="h-12 rounded-lg bg-slate-100" />
          ))}
        </div>
      </div>
    </div>
  );
}
